import React from "react";
import { StatusPill } from "../../../../components/ui/PageBits";
import { isActiveBooking } from "../../bookingService";

export const SHOP_CTX_KEY = "haki_booking_shop_ctx";

export function getShopCtx(shops) {
    try {
        const id = localStorage.getItem(SHOP_CTX_KEY);
        if (id && shops.some((s) => s.id === id)) return id;
    } catch {
        /* ignore */
    }
    return (shops.find((s) => s.status === "active") || shops[0])?.id || "";
}

export function setShopCtx(id) {
    try {
        localStorage.setItem(SHOP_CTX_KEY, id);
    } catch {
        /* ignore */
    }
}

export function BookingStatusPill({ status }) {
    const tones = {
        confirmed: "green", pending: "amber", completed: "blue",
        cancelled: "zinc", noshow: "red", active: "green", suspended: "red",
    };
    return <StatusPill tone={tones[status] || "zinc"}>{status}</StatusPill>;
}

/** Aggregate a shop's bookings into customer profiles. */
export function groupCustomers(bookings) {
    const map = {};
    for (const b of bookings || []) {
        const key = `${(b.customer || "").trim().toLowerCase()}|${(b.email || "").trim().toLowerCase()}`;
        if (!map[key]) {
            map[key] = {
                key,
                name: b.customer || "(no name)",
                email: b.email || "",
                phone: b.phone || "",
                bookings: [],
            };
        }
        const c = map[key];
        c.bookings.push(b);
        if (b.phone && !c.phone) c.phone = b.phone;
    }
    const tk = todayKeyLocal();
    return Object.values(map)
        .map((c) => {
            const sorted = [...c.bookings].sort((a, b2) =>
                `${b2.date} ${b2.start}`.localeCompare(`${a.date} ${a.start}`)
            );
            const active = c.bookings.filter(isActiveBooking);
            return {
                ...c,
                bookings: sorted,
                total: c.bookings.length,
                upcoming: active.filter((x) => x.date >= tk).length,
                pending: c.bookings.filter((x) => x.status === "pending").length,
                completed: c.bookings.filter((x) => x.status === "completed").length,
                lastDate: sorted.length ? sorted[0].date : "",
            };
        })
        .sort((a, b2) => (b2.total - a.total) || b2.lastDate.localeCompare(a.lastDate));
}

function todayKeyLocal() {
    const d = new Date();
    const pad = (n) => (n < 10 ? "0" : "") + n;
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function ShopSwitcher({ shops, value, onChange }) {
    if (!shops.length) return null;
    return (
        <label className="flex items-center gap-2 text-sm">
            <span className="text-xs font-bold uppercase tracking-widest text-[#64748b]">Viewing as</span>
            <select className="hk-select" style={{ width: "auto" }} value={value} onChange={(e) => onChange(e.target.value)}>
                {shops.map((s) => (
                    <option key={s.id} value={s.id}>
                        {s.business}{s.status !== "active" ? " (suspended)" : ""}
                    </option>
                ))}
            </select>
        </label>
    );
}
